
export function empty(text: string|null|undefined) {
    if (text?.trim()) return false;
    return true;
}